<form [formGroup]="formGroup"
    class="relative flex items-center w-full text-inherit p-0 mt-2 h-[40px] md:h-[45px] dropdown"
    [class]="[config.roundedFull?'rounded-full':'rounded-md',manageStyleClass()]">
    <div
        *ngIf="(selectedItem && !isNotExist(itemsObs|async) && !isMobile() && type=='school') || (selectedItem && !isNotExist(itemsObs|async) && selectedItem.logo && !isMobile() && type=='organ')"
        @widthAnimation 
        class="w-6 h-6 aspect-square mr-3 rounded-md overflow-hidden flex items-center justify-center dark:bg-darkMode-100">
        <img *ngIf="selectedItem.logo" [src]="selectedItem.logo"
            [alt]="selectedItem.name" class="min-w-full h-full object-contain">
        <img *ngIf="!selectedItem.logo" src="assets/image/default.webp"
            [alt]="selectedItem.name" class="min-w-full min-h-full">
    </div>
    <div *ngIf="isMobile()"
        class="w-full m-0 pr-3 flex justify-between items-center pl-1 lg:pl-2 text-inherit bg-transparent border-none bg-lightBG dark:bg-darkBG select-none rounded-full">
        <div (click)="openMobileSelection()"
            class="flex items-center w-full-m-7">
            <div
                *ngIf="(selectedItem && type=='school') || (selectedItem && type=='organ')"
                class="rounded-md">
                <img *ngIf="selectedItem.logo" [src]="selectedItem.logo"
                    [alt]="selectedItem.name"
                    class="mr-3 w-6 h-6 aspect-square rounded-md overflow-hidden flex items-center justify-center dark:bg-darkMode-200">
                <img *ngIf="!selectedItem.logo" src="assets/image/default.webp"
                    [alt]="selectedItem.name"
                    class="mr-3 w-6 h-6 aspect-square rounded-md overflow-hidden flex items-center justify-center dark:bg-darkMode-200">
            </div>
            <div class="px-3 py-2 md:py-3 text-lightMode-700 dark:text-darkMode-300 truncate">
                {{selectedItem ? selectedItem.name:'جستجو کنید'}}
            </div>
        </div>
        <button matRipple
            class="p-1 pl-0 w-7 h-7 rounded-full overflow-hidden  text-lightMode-700 dark:text-darkMode-300"
            (click)="resetSelectedItem()">
            <mat-icon class="mat-center text-base lg:text-lg">
                close
            </mat-icon>
        </button>
    </div>
    <input #searchSelectInput *ngIf="!isMobile()" formControlName="control"
        [placeholder]="type=='organ'? 'مثال: موسسه انرژی اتمی' :type=='work_field'? 'مثال: نانو': type=='city'? 'مثال: تهران' : type=='software'? 'مثال: Excel' : type=='language' ? 'مثال: English' : type=='skill' ? 'مثال: ارتباط گیری موثر' : type=='school' ? 'مثال: دانشگاه تهران' : type=='field' ? 'مثال: مهندسی مکانیک':'' "
        maxlength="100" [(ngModel)]="cloneItem.name" type="text"
        class="dropdown-toggle w-full m-0 py-2 px-3 text-inherit text-lightMode-700 dark:text-darkMode-300 bg-transparent border-none border-0 ease-in-out outline-0 "
        [class]="[config.rounded?'rounded-3xl':'rounded-md',specificHeight?'specific-height':'']"
        (focus)="focus($event)" (focusin)="changeFocus(true)"
        (focusout)="changeFocus(false)">
    <!-- <button *ngIf="canCreateString() && false" (click)="createString()" class="h-7 flex items-center justify-center mx-2 bg-lightPrimary dark:bg-lightPrimary rounded-[4px] px-2 z-50 text-lightBG">
        ایجاد
    </button> -->
    <div *ngIf="(itemsObs | async) as items"
    [class]="getIsShowOnBottom() ? 'absolute top-full right-0 w-full pt-2 z-20' : 'absolute bottom-full right-0 w-full pb-2 z-20'">

        <div *ngIf="!items.length"
            class="w-full text-center p-3 rounded-md text-lightMode-700 dark:text-darkMode-300 bg-lightBG dark:bg-darkBG max-h-[150px] overflow-y-auto border-site relative">
            موردی یافت نشد
        </div>

        <div *ngIf="items.length > 0" tabindex="0"
            class="dropdown-menu w-full rounded-md bg-lightCardBG dark:bg-darkCardBG max-h-[150px] overflow-y-auto border-site relative">
            <div tabindex="0" *ngFor="let item of items; let i = index;"
                (click)="selectItem(item)"
                class="item-child flex relative items-center w-full px-2 py-3 cursor-pointer transition-colors ease-in-out duration-150 hover:bg-gray-500 text-lightMode-700 dark:text-darkMode-300 hover:text-white bg-opacity-30 border-lightMode-200 dark:border-darkMode-700 z-30"
                [class]="i < items.length - 1 ? 'border-b' : ''">
                <div *ngIf="type == 'school' || type == 'organ'"
                    class="w-8 h-8 flex items-center justify-center overflow-hidden rounded-md ml-3 dark:bg-darkMode-100">
                    <img 
                    onerror="this.onerror=null; this.src='assets/image/default.webp';"
                    *ngIf='item.logo' [src]="item.logo" [alt]="item.name" class="min-w-full min-h-full">
                    <img *ngIf='!item.logo' src="assets/image/default.webp" [alt]="item.name" class="min-w-full min-h-full">
                </div>

                <span *ngIf="type != 'city' && type != 'language'">{{ item.name }}</span>
                <span *ngIf="type == 'city'">{{ item.name }}، {{ item.province }}، {{ item.country }}</span>
                <span *ngIf="type == 'language'">{{ item.name }} ({{ item.native_name }})</span>

            </div>
        </div>
        <div class="fixed top-0 right-0 w-screen h-screen"
            (click)="reset()"></div>
    </div>
</form>
